export const FREE_PLAN_ID = 0
export const LITE_PLAN_ID = 27
export const PRO_PLAN_ID = 28
export const BUSINESS_PLAN_ID = 29
export const PRO_AI = 31
export const WEEKLY_RECURRENCE = 'weekly'

export type TUserPlan =
  | typeof FREE_PLAN_ID
  | typeof LITE_PLAN_ID
  | typeof PRO_PLAN_ID
  | typeof BUSINESS_PLAN_ID
  | typeof PRO_AI

export const USER_PLANS = {
  [FREE_PLAN_ID]: 'Free',
  [LITE_PLAN_ID]: 'Lite',
  [PRO_PLAN_ID]: 'Pro',
  [BUSINESS_PLAN_ID]: 'Business'
}

export const USER_PLAN_TO_QUALITIES: Record<TUserPlan, number[]> = {
  [FREE_PLAN_ID]: [720],
  [LITE_PLAN_ID]: [720, 1080],
  [PRO_PLAN_ID]: [720, 1080],
  [BUSINESS_PLAN_ID]: [720, 1080],
  [PRO_AI]: [720, 1080]
}

export const USER_PLAN_TO_MAX_DURATION: Record<TUserPlan, number> = {
  [FREE_PLAN_ID]: 3 * 60, // 3 minutes
  [LITE_PLAN_ID]: 30 * 60, // 30 minutes
  [PRO_PLAN_ID]: 30 * 60, // 30 minutes
  [BUSINESS_PLAN_ID]: 30 * 60, // 30 minutes
  [PRO_AI]: 30 * 60 // 30 minutes
}
